import React from 'react';
export function Footer() {
  return <footer className="w-full bg-deep px-4 py-12 text-center text-white/65" data-id="element-91" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-3xl" data-id="element-92" data-mp="3ggar7wn6mf5z">
        <p className="font-display text-2xl font-bold text-white" data-id="element-93" data-mp="3ghc4m7ro7dqv">Step Class Ready™</p>
        <p className="mt-3 text-sm font-semibold text-white/80" data-id="element-94" data-mp="32pp57z2flp3v">
          The #1 implementation system for professional step instructors.
        </p>
        <p className="mt-3 text-sm leading-relaxed" data-id="element-95" data-mp="3ueim7z0nr6ei">
          Because professional step teaching deserves a real professional system.
        </p>
        <p className="mt-6 text-sm" data-id="element-96" data-mp="37xwcimca4j2">
          📧{' '}
          <a className="transition-colors hover:text-green" href="mailto:support@eurekalabs.com" data-id="element-97" data-mp="3lf582t1l9tng">
            support@eurekalabs.com
          </a>{' '}
          <span className="mx-2 text-white/30" data-id="element-98" data-mp="3qfjgwdb0l7mj">·</span> 🌐 www.eurekalabs.store
        </p>
        <p className="mt-6 text-xs" data-id="element-99" data-mp="29xvrce9uhfpu">© Step Class Ready™ 2026 — All rights reserved.</p>
        <p className="mt-4 text-xs leading-relaxed text-white/45" data-id="element-100" data-mp="2ezuvhqdesgnu">
          This product is a digital download. Results may vary. This system does not replace medical advice or
          professional certification.
        </p>
      </div>
    </footer>;
}